'use client';

import animationData from '@/animations/workflows.json';
import { FC } from 'react';
import LottieHandler from './LottieHandler';

export interface AnimationWorkflowsProps {
  playing?: boolean;
}

const AnimationWorkflows: FC<AnimationWorkflowsProps> = ({ playing }) => {
  return (
    <div className="flex">
      <LottieHandler animationData={animationData} playing={playing} />
    </div>
  );
};

export default AnimationWorkflows;
